// @flow

import firebase from '@firebase/app';

// Put Firebase config object in firebaseConfig.js
import config from './firebaseConfig';

firebase.initializeApp(config);
const app = () => firebase.app();

const databaseAsync = async () => {
  await import(/*webpackChunkName: 'firebase-database'*/ '@firebase/database');
  return firebase.database();
};
const authAsync = async () => {
  await import(/*webpackChunkName: 'firebase-auth'*/ '@firebase/auth');
  return firebase.auth();
};
const authRefAsync = async () => {
  await import(/*webpackChunkName: 'firebase-auth'*/ '@firebase/auth');
  return firebase.auth;
};

export const encodeFirebaseKey = key => {
  return encodeURIComponent(key).replace(/\./g, '%2E');
};

export const decodeFirebaseKey = key => {
  return decodeURIComponent(key);
};

export default {
  app: app,
  auth: authAsync,
  authRef: authRefAsync,
  database: databaseAsync
};



// WEBPACK FOOTER //
// ./utils/firebase.js